import { ApolloError, ServerError, ServerParseError } from '@apollo/client'

import { ErrorEntity } from 'src/types'

export const ErrorTranslator = {
  toEntities: (apolloError: ApolloError): ErrorEntity[] => {
    const graphQLErrors: ErrorEntity[] =
      apolloError.graphQLErrors?.map(error => {
        return {
          message: error.message,
          statusCode: error.extensions.status as number,
        }
      }) ?? []

    // networkErrorだった場合、エラー状況に応じてstatusCodeの格納先が異なる
    let parseErrorStatusCode: number | undefined
    let serverErrorStatusCode: number | undefined
    if (
      apolloError.networkError?.name === 'ServerParseError' ||
      apolloError.networkError?.name === 'ServerError'
    ) {
      parseErrorStatusCode = (apolloError.networkError as ServerParseError).statusCode
      serverErrorStatusCode = (apolloError.networkError as ServerError).statusCode
    }

    const netWorkError: ErrorEntity | null = apolloError.networkError
      ? {
          message: apolloError.networkError.message,
          statusCode: (parseErrorStatusCode || serverErrorStatusCode) as number,
        }
      : null

    return netWorkError ? [netWorkError, ...graphQLErrors] : graphQLErrors
  },
} as const
